<template>
  <div class="cancellation-survey-header">
    <h2 class="cancellation-survey-header__headline container">
      {{ this.isLeavingMup ? $t("headlineMultiUserPlan") : $t("headline") }}
    </h2>
  </div>
</template>

<script>
export default {
  name: "CancellationSurveyHeader",
  props: {
    isLeavingMup: {
      type: Boolean,
      default: false
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "Cancel your subscription",
        headlineMultiUserPlan: "Leave shared plan"
      },
      de: {
        headline: "Abo kündigen",
        headlineMultiUserPlan: "Geteiltes Abo verlassen"
      },
      es: {
        headline: "Cancelar tu suscripción",
        headlineMultiUserPlan: "Dejar plan compartido"
      },
      pt: {
        headline: "Cancelar a tua subscrição",
        headlineMultiUserPlan: "Sair do plano partilhado"
      }
    }
  }
}
</script>

<style lang="scss">
.cancellation-survey-header {
  padding-top: $spacing-48;
  padding-bottom: $spacing-32;

  background-color: $grey-pale;

  &__headline {
    @include font-style(h2);
    @include cursored;

    text-align: center;

    &:after {
      align-self: center;
    }
  }
}
</style>
